<template>
  <div class="page-wrapper">
    <van-swipe :autoplay="3000" indicator-color="#D70D18 ">
      <van-swipe-item v-for="(item, index) in currentSwiperItems" :key="index">
        <img v-lazy="item.localUrl" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import Vue from 'vue'
import { Lazyload } from 'vant'
import { getData } from '@/request/api/model'
Vue.use(Lazyload)
export default {
  name: 'MobileHome',
  data() {
    return {
      language: localStorage.getItem('Language'),
      swiperItemsCN: [],
      swiperItemsEN: []
    }
  },
  created() {
    if (this.language === 'zh-CN') {
      this.getCNData()
    } else {
      this.getENData()
    }
  },
  components: {},

  computed: {
    currentSwiperItems() {
      return this.language === 'zh-CN' ? this.swiperItemsCN : this.swiperItemsEN
    }
  },
  mounted() {},

  methods: {
    async getCNData() {
      this.swiperItemsCN = await this.getSlideshowData('0,1')
    },
    async getENData() {
      this.swiperItemsEN = await this.getSlideshowData('0,2')
    },
    async getSlideshowData(contentType) {
      try {
        const res = await getData({
          categoryId: '2077634653602623489',
          contentType,
          publishChannel: '0,2'
        })

        if (!res || res.code !== 0 || !Array.isArray(res.data)) {
          return []
        }

        return res.data.reduce((list, item) => {
          const fileList = Array.isArray(item.contentFileList) ? item.contentFileList : []
          const localUrl = fileList.find((url) => typeof url === 'string' && url.trim())
          if (localUrl) {
            list.push({
              localUrl
            })
          }
          return list
        }, [])
      } catch (error) {
        console.error(error)
        return []
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.page-wrapper {
  height: 100%;
  width: 100%;
  .van-swipe {
    height: 100%;
    /deep/ .van-swipe-item {
      height: 100%;
      img {
        height: 100%;
        width: 100%;
      }
    }
    /deep/ .van-swipe__indicators {
      bottom: 6.0649vh;
      // width: 1.3333vw;
      // height: 1.3333vw;
      // background-color: #ebedf0;
      // border-radius: 100%;
      // opacity: 0.6;
      // transition: opacity 0.2s, background-color 0.2s;
      // &:not(:last-child) {
      //   margin-right: 2.6667vw;
      // }
      // &.active {
      //   background-color: #d70d18;
      //   opacity: 1;
      // }
    }
  }
}
</style>